(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-clm]';
    const states = new WeakMap();

    function hideClone(item) {
      item.setAttribute('data-clm-clone', '');
      item.setAttribute('aria-hidden', 'true');

      // Do not duplicate theme-editor block identifiers or HTML IDs.
      [item, ...item.querySelectorAll('*')].forEach((element) => {
        element.removeAttribute('id');
        element.removeAttribute('data-shopify-editor-block');
      });

      item.querySelectorAll('a, button, input, select, textarea, [tabindex]')
        .forEach((element) => element.setAttribute('tabindex', '-1'));

      return item;
    }

    function initialize(root) {
      const viewport = root.querySelector('.clm__viewport');
      const track = root.querySelector('.clm__track');
      const original = root.querySelector('[data-clm-original]');
      const duplicate = root.querySelector('[data-clm-duplicate]');

      if (!viewport || !track || !original || !duplicate) return;

      const baseItems = Array.from(original.children)
        .filter((item) => !item.hasAttribute('data-clm-clone'));

      if (!baseItems.length || viewport.clientWidth === 0) return;

      // Measure the unextended set without destroying existing clones.
      const baseWidth = baseItems.reduce(
        (width, item) => width + item.getBoundingClientRect().width,
        0
      );

      if (baseWidth <= 0) return;

      const repeatCount = Math.max(1, Math.ceil(viewport.clientWidth / baseWidth));
      const speed = Math.max(1, Number(root.dataset.clmSpeed) || 4);
      const signature = `${baseWidth}:${repeatCount}:${speed}`;
      const previous = states.get(root);

      // Avoid restarting an unchanged animation on editor/resize events.
      if (previous && previous.signature === signature) return;

      const oldAnimation = track.getAnimations()[0];
      const oldTime = oldAnimation ? oldAnimation.currentTime : null;

      original.querySelectorAll('[data-clm-clone]').forEach((item) => item.remove());

      const extraItems = document.createDocumentFragment();

      for (let repeat = 1; repeat < repeatCount; repeat += 1) {
        baseItems.forEach((item) => {
          extraItems.appendChild(hideClone(item.cloneNode(true)));
        });
      }

      original.appendChild(extraItems);

      // Rebuild the second half from the completed first half.
      // Equal item counts and equal padding guarantee equal widths.
      const secondHalf = document.createDocumentFragment();

      Array.from(original.children).forEach((item) => {
        secondHalf.appendChild(hideClone(item.cloneNode(true)));
      });

      duplicate.replaceChildren(secondHalf);

      const listWidth = original.getBoundingClientRect().width;
      const duration = listWidth / (speed * 20);

      root.style.setProperty('--clm-duration', `${duration}s`);
      root.setAttribute('data-clm-ready', '');

      // Preserve travelled distance when resizing changes the duration.
      const newAnimation = track.getAnimations()[0];
      if (newAnimation && typeof oldTime === 'number') {
        newAnimation.currentTime = oldTime;
      }

      states.set(root, { signature });
    }

    function initializeWithin(scope) {
      if (scope.matches && scope.matches(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeWithin(document);
      }, { once: true });
    } else {
      initializeWithin(document);
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => initializeWithin(document), 150);
    }, { passive: true });

    document.addEventListener('shopify:section:load', (event) => {
      initializeWithin(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest(selector);
      if (root) initialize(root);
    });

    window.addEventListener('pageshow', () => initializeWithin(document));
  })();

  } catch(e) { console.error(e); }
})();
})();
